import tmhRequest from '@/config/tmhRequest'


export default {
    dealMeituanOrder: function (data) {
        return tmhRequest({
            url: '/order/tmh/meituanorder/dealmeituanorder',
            method: 'post',
            params: data,
        })
    },

    searchListClassify: function (data) {
        return tmhRequest({
            url: '/order/tmh/meituanorder/searchlistclassify',
            method: 'post',
            params: data,
        })
    },

    searchListMeituanOrder: function (data) {
        return tmhRequest({
            url: '/order/tmh/meituanorder/searchlistmeituanorder',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/order/meituanorder.js